import React from 'react';

import { createClassName } from 'utils/createClassName';

import './adminPageTitleLayoutStyles.scss';

type Props = {
  textNode: React.ReactNode;
  actionNode: React.ReactNode;
};

export const AdminPageTitleLayout = (props: Props) => {
  const { textNode, actionNode } = props;

  const createElementClassName = createClassName('admin-page-title-layout');

  return (
    <div className={createElementClassName('wrapper')}>
      <div className={createElementClassName('text-slot')}>{textNode}</div>
      <div className={createElementClassName('action-slot')}>{actionNode}</div>
    </div>
  );
};
